import { render, staticRenderFns } from "./StandaloneContacts.vue?vue&type=template&id=ffc327be&scoped=true&"
import script from "./StandaloneContacts.vue?vue&type=script&lang=js&"
export * from "./StandaloneContacts.vue?vue&type=script&lang=js&"
import style0 from "./StandaloneContacts.vue?vue&type=style&index=0&id=ffc327be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffc327be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ffc327be')) {
      api.createRecord('ffc327be', component.options)
    } else {
      api.reload('ffc327be', component.options)
    }
    module.hot.accept("./StandaloneContacts.vue?vue&type=template&id=ffc327be&scoped=true&", function () {
      api.rerender('ffc327be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/workPermits/StandaloneContacts.vue"
export default component.exports